import React from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader";
import Error from "./Error";

/**
 * App-wide overlays that must be available on every screen (including the
 * public login screen): the loading spinner and the error modal.
 */
const GlobalOverlays = () => {
  const loading = useSelector((state) => state.ui.loading);
  return (
    <>
      {loading && <Loader />}
      <Error />
    </>
  );
};

export default GlobalOverlays;
